/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelProjectRequest
 */
export interface CancelProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelProjectRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the CancelProjectRequest interface.
 */
export function instanceOfCancelProjectRequest(value: object): value is CancelProjectRequest {
    return true;
}

export function CancelProjectRequestFromJSON(json: any): CancelProjectRequest {
    return CancelProjectRequestFromJSONTyped(json, false);
}

export function CancelProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelProjectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function CancelProjectRequestToJSON(value?: CancelProjectRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

